export const AUTH_MODES = {
  ALLAUTH: 'allauth',
  FASTAPI: 'fastapi',
  GOOGLE: 'google',
}

export function getAuthMode() {
  const mode = String(import.meta.env.VITE_AUTH_MODE || AUTH_MODES.GOOGLE)
    .trim()
    .toLowerCase()

  if (mode === AUTH_MODES.ALLAUTH) return AUTH_MODES.ALLAUTH
  if (mode === AUTH_MODES.FASTAPI) return AUTH_MODES.FASTAPI
  return AUTH_MODES.GOOGLE
}
